import { Descendant } from 'slate';
import ELEMENTS from '~/components/PluginsEditor/components/elements/elementsEnum';
import getVariablesAsMappings from '~/components/PluginsEditor/utils/flows/getVariablesAsMappings';
import serializeAllElements from '~/components/PluginsEditor/utils/serialize';
import serializeAsPlainText from '~/components/PluginsEditor/utils/serializeAsPlainText';
import { FlowAction, FlowV2_TemplateStringFragment } from '~/graphql/types';
import { ClientFlowAction } from '~/graphql/types.client';

/**
 * Convert slate values into template &amp; mappings in actions that use the DHEditor
 * @param {ClientFlowAction} changes -Changes made in the action
 * keywords:
 */
const serializeEditorValues = (changes: ClientFlowAction): ClientFlowAction => {
  switch (changes.actionType) {
    case FlowAction.SendEmailPlain: {
      const { bodyValue, subjectValue, body, subject, ...rest } = changes;
      let updatedSubject = subject;
      let updatedBody = body;

      if (subjectValue) {
        updatedSubject = serializeSimpleField(subjectValue);
      }

      if (bodyValue) {
        updatedBody = {
          __typename: 'FlowV2_TemplateString',
          template: serializeAllElements({
            fragment: bodyValue,
            customElements: [
              ELEMENTS.VARIABLE,
              ELEMENTS.DH_IMAGE,
              ELEMENTS.IMAGE,
            ],
          }),
          mappings: getVariablesAsMappings(bodyValue),
        };
      }

      return {
        ...rest,
        subject: updatedSubject,
        body: updatedBody,
      };
    }

    case FlowAction.ContactDetails: {
      const { nameValue, phoneValue, name, phone, ...rest } = changes.field;

      let updatedName = name;
      if (nameValue) {
        updatedName = serializeSimpleField(nameValue);
      }

      let updatedPhone = phone;
      if (phoneValue) {
        updatedPhone = serializeSimpleField(phoneValue);
      }

      return {
        ...changes,
        field: { ...rest, name: updatedName, phone: updatedPhone },
      };
    }

    case FlowAction.TaskCreate: {
      const { titleValue, descriptionValue, title, description, ...rest } =
        changes;

      let updatedTitle = title;
      let updatedDescription = description;

      if (titleValue) {
        updatedTitle = serializeSimpleField(titleValue);
      }

      if (descriptionValue) {
        updatedDescription = {
          __typename: 'FlowV2_TemplateString',
          template: serializeAllElements({
            fragment: descriptionValue,
            customElements: [ELEMENTS.VARIABLE],
          }),
          mappings: getVariablesAsMappings(descriptionValue),
        };
      }

      return {
        ...rest,
        title: updatedTitle,
        description: updatedDescription,
      };
    }

    case FlowAction.RealworksSendContact: {
      const { description, descriptionValue, ...rest } = changes;

      let updatedDescription = description;
      if (descriptionValue) {
        updatedDescription = {
          __typename: 'FlowV2_TemplateString',
          template: serializeAllElements({
            fragment: descriptionValue,
            customElements: [ELEMENTS.VARIABLE],
          }),
          mappings: getVariablesAsMappings(descriptionValue),
        };
      }

      return {
        ...rest,
        description: updatedDescription,
      };
    }

    default:
      return changes;
  }
};

const serializeSimpleField = (
  value: Array<Descendant>,
): FlowV2_TemplateStringFragment => ({
  __typename: 'FlowV2_TemplateString',
  template: serializeAsPlainText({
    fragment: value,
    customElements: [ELEMENTS.VARIABLE],
  }),
  mappings: getVariablesAsMappings(value),
});

export default serializeEditorValues;
